import gqlRequest from 'graphql/generic';

type GetBlockchainDataParams = {
  dataId: string;
};

const query = `
  query GetBlockchainData($dataId: String!) {
    getBlockchainData(data_id: $dataId)
  }`;

export const getBlockchain = (dataId: string) => gqlRequest<void, GetBlockchainDataParams>(query, { dataId });
